// extracted by mini-css-extract-plugin
export default {"avatar":"HeroSection_avatar__mAUQN","orbit":"HeroSection_orbit__PN6lO","spin":"HeroSection_spin__NJRBZ"};